const areZonesConfiguredForStore = store => {
  //store has no zones
  if (!store.zoneConfiguration || store.zoneConfiguration.length === 0) {
    return false;
  }
  //configured zones
  const allConfiguredZones = store.zoneConfiguration.map(newItem => {
    return newItem.zone.zoneId;
  });
  //configured zones that have no scenes
  const zonesWithNoScenes = store.zoneConfiguration
    .filter(x => {
      if (!x.scenes || x.scenes.length === 0) return x.zone.zoneId;
      return null;
    })
    .map(newItems => {
      return newItems.zone.zoneId;
    });
  //all zones that are not configured for store
  const zonesNotconfiguredForStore = store.storeConfiguration.zones
    .filter(zone => {
      if (!allConfiguredZones.includes(zone.zone.zoneId)) {
        return zone;
      }
      return null;
    })
    .map(newItem => {
      return newItem.zone.zoneId;
    });
  //none duplicate zoneids that have either no scenes or are
  //not configured zone for store
  const notConfiguredZones = new Set([
    ...zonesWithNoScenes,
    ...zonesNotconfiguredForStore
  ]);
  return notConfiguredZones.size === 0;
};

export default areZonesConfiguredForStore;
